import React, { useState } from "react";
import { Link } from "react-router-dom";
import Product from "./Product";
import { SpeedInsights } from "@vercel/speed-insights/react"
import "../styles/Home.css";

const featuredProducts = [
  { id: 1, name: "Bubble Gum", image: "/images/product1-img1.png", price: 109000 },
  { id: 2, name: "Ret Vanilla", image: "/images/product2-img1.png", price: 79000 },
  { id: 3, name: "Romant Wis", image: "/images/product5-img1.png", price: 79000 },
  { id: 4, name: "Vanilla Cake", image: "/images/product6-img1.png", price: 89000 },
];

const Home = () => {
  const [isLaunching] = useState(false);

  return (
    <div className={`home ${isLaunching ? 'home-content' : ''}`}>
      {isLaunching && (
        <div className="overlay">
          <div>
            <h2>Coming Soon</h2>
          </div>
        </div>
      )}
      <div className="hero">
        <div className="container">
          <h1>Discover Your Signature Scent</h1>
          <p>Handcrafted perfumes for the modern individual</p>
          <Link to="/shop" className="btn">
            Shop Now
          </Link>
        </div>
      </div>
      <div className="featured-products container">
        <h2>Featured Products</h2>
        <div className="product-grid">
          {featuredProducts.map((product) => (
            <Product 
              key={product.id}
              id={product.id}
              name={product.name}
              image={product.image}
              price={product.price}
            />
          ))}
        </div>
      </div>
      <SpeedInsights />
    </div>
  );
};

export default Home;